export type ErrorInfo = { title: string; message: string; image: string };

export enum ErrorCode {
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnknownError = 500,
}
